import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";

export const Page404 = () => {
  return (
    <div>
      <h1>404 Not Found</h1>
      <p>URL {window.location.href} not found.</p>
      <Button href={window.location.origin} variant="text-muted" iconAfter={LongArrowForwardIcon}>
        Home page
      </Button>
    </div>
  );
};
